<template>
  <!-- `.sms-portal` scopes the brand component layer; `.dark` drives Tailwind's
       class-based dark variant + the dark CSS-var overrides on this wrapper. -->
  <div class="sms-portal" :class="{ dark: isDark }">
    <div class="flex flex-col font-body" style="min-height: calc(100vh - 56px)">
      <!-- Slim portal header. The app's global nav/sign-out live in the admin
           chrome (left-menu / top-menu); this bar only carries portal identity,
           the dark toggle, and the signed-in tier. -->
      <header
        class="sticky top-0 z-20 h-14 flex items-center justify-between px-4 border-b border-gray-200 dark:border-dark-border bg-white bg-opacity-80 dark:bg-dark-surface dark:bg-opacity-80"
      >
        <div class="flex items-center gap-2">
          <div
            class="w-7 h-7 rounded-lg bg-brand-teal text-white flex items-center justify-center"
          >
            <message-square-icon size="1x" class="w-4 h-4" />
          </div>
          <div class="leading-tight">
            <div class="font-heading font-bold text-sm">
              SMS Self-Serve Portal
            </div>
            <div
              class="text-[11px] text-gray-500 dark:text-dark-text-muted -mt-0.5"
            >
              Callia Core · Phase 1
            </div>
          </div>
        </div>

        <div class="flex items-center gap-2">
          <button
            class="btn btn-ghost btn-sm"
            :aria-label="
              isDark ? 'Switch to light mode' : 'Switch to dark mode'
            "
            :title="isDark ? 'Light mode' : 'Dark mode'"
            @click="toggleTheme"
          >
            <sun-icon v-if="isDark" size="1x" class="w-4 h-4" />
            <moon-icon v-else size="1x" class="w-4 h-4" />
          </button>

          <div
            class="flex items-center gap-2 pl-2 border-l border-gray-200 dark:border-dark-border"
          >
            <div
              class="w-8 h-8 rounded-full text-xs font-semibold flex items-center justify-center flex-shrink-0"
              :class="avatarClass"
            >
              {{ initials }}
            </div>
            <div class="leading-tight hidden sm:block">
              <div class="text-[13px] font-semibold">{{ displayName }}</div>
              <div class="text-[11px] text-gray-500 dark:text-dark-text-muted">
                {{ tierLabel }}
              </div>
            </div>
          </div>
        </div>
      </header>

      <main class="flex-1 overflow-auto app-scroll" role="main">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script setup>
import { MessageSquareIcon, MoonIcon, SunIcon } from "vue-feather-icons";
import { useSmsTheme } from "./composables/useSmsTheme";
import { useSmsTier } from "./composables/useSmsTier";
import "./styles/sms-portal.css";

const { isDark, toggleTheme } = useSmsTheme();
const { tierLabel, displayName, initials, avatarClass } = useSmsTier();
</script>
